import { useComponentState } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import Link from "next/link";
import { useRouter } from "next/router";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Button,
  Card,
  Col,
  Form,
} from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import constants from "src/constants";
import gutter from "src/functions/gutter";
import { sButton } from "src/styles/sButton.module.scss";
import { sFormAccordion } from "src/styles/sFormAccordion.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sNote } from "src/styles/sNote.module.scss";

function FormJoinUsPhotos() {
  var toggleAccordion = useComponentState(false);
  const { locale: lang } = useRouter();
  return (
    <Accordion
      defaultActiveKey={`1`}
      className={composeClassNames([sFormAccordion, "joinus-"])}
    >
      <Card>
        <AccordionToggle eventKey={`0`}>
          <Heading
            type={`h2`}
            title={
              <>
                {`6. `}
                <Translate tKey={`Photos`} />
                <Text size={`md`} width={`regular`}>
                  {`3 `}
                  <Translate tKey={`min.`} />
                </Text>
              </>
            }
          />
        </AccordionToggle>
        <AccordionCollapse eventKey={`0`}>
          <Card.Body>
            <Paragraph style={gutter(`margin`, `top`, `0`)} size={`xn`}>
              <Translate
                tKey={`You can zip and save the following photos using a web repository, eg:`}
              />
              {` `}
              <Link
                href={(function () {
                  switch (lang) {
                    case `cs`:
                      return constants.Paths.publicTransferCS;
                    case `sk`:
                      return constants.Paths.publicTransferSK;
                    case `en`:
                      return constants.Paths.publicTransferEN;
                    default:
                      return constants.Paths.publicTransferEN;
                  }
                })()}
                passHref
                locale={false}
              >
                <Button
                  type={`button`}
                  variant={`link`}
                  as={`a`}
                  className={composeClassNames([sButton, "btn-inline"])}
                  target={`_blank`}
                >
                  {(function () {
                    switch (lang) {
                      case `cs`:
                        return constants.Paths.publicTransferCS;
                      case `sk`:
                        return constants.Paths.publicTransferSK;
                      case `en`:
                        return constants.Paths.publicTransferEN;
                      default:
                        return constants.Paths.publicTransferEN;
                    }
                  })()}
                </Button>
              </Link>
              {` `}
              <Translate
                tKey={`and than copy the links to the following fields, or send them to our email:`}
              />
              {` `}
              <Link
                href={
                  `mailto:` +
                  (function () {
                    switch (lang) {
                      case `cs`:
                        return constants.Paths.profileEmailCS;
                      case `sk`:
                        return constants.Paths.profileEmailSK;
                      case `en`:
                        return constants.Paths.profileEmailEN;
                      default:
                        return constants.Paths.profileEmailEN;
                    }
                  })()
                }
                passHref
                locale={false}
              >
                <Button
                  type={`button`}
                  variant={`link`}
                  as={`a`}
                  className={composeClassNames([sButton, "btn-inline"])}
                  target={`_blank`}
                >
                  {(function () {
                    switch (lang) {
                      case `cs`:
                        return constants.Paths.profileEmailCS;
                      case `sk`:
                        return constants.Paths.profileEmailSK;
                      case `en`:
                        return constants.Paths.profileEmailEN;
                      default:
                        return constants.Paths.profileEmailEN;
                    }
                  })()}
                </Button>
              </Link>
              {`.`}
            </Paragraph>
            <Form.Row>
              <Col sm={8} xs={12}>
                <Form.Group>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Profile and motive photo`} />
                  </Form.Label>
                  <Form.Control
                    className={sFormControl}
                    name={`profile-photos`}
                    id={`profile-photos`}
                  />
                  <Form.Text className={sNote}>
                    <Translate
                      tKey={`The profile photo should be a square-size with a minimum size 720 x 720 px.`}
                    />
                    {` `}
                    <Translate
                      tKey={`The theme photo, which will be placed at the top of the profile, should have an elongated dimension with a minimum size 1920 x 640 px.`}
                    />
                  </Form.Text>
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col sm={8} xs={12}>
                <Form.Group>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Photo gallery`} />
                    {` (`}
                    <Translate tKey={`max. 12 photos`} />
                    {`)`}
                  </Form.Label>
                  <Form.Control
                    className={sFormControl}
                    name={`photo-gallery`}
                    id={`photo-gallery`}
                  />
                  <Form.Text className={sNote}>
                    <Translate
                      tKey={`You can also have a photo gallery on your profile. If you want, than send us a maximum of 12 square photos with a minimum size of 1080 x 1080 px.`}
                    />
                  </Form.Text>
                </Form.Group>
              </Col>
            </Form.Row>
          </Card.Body>
        </AccordionCollapse>
      </Card>
    </Accordion>
  );
}

export default FormJoinUsPhotos;
